import { useEffect, useState } from "react";

import { Button } from "@components/Button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@components/Dialog";
import { Textarea } from "@components/Textarea";
import { Typography } from "@components/Typography";

import { useCreateRemarkMutation, useUpdateRemarkMutation } from "@storage/queries/remarks";

interface UpdateRemarkDialogProps {
	userId: string;
	remark: string | null;
	nickname: string;
	isExistRemark: boolean;
	onClose: () => void;
}

export const UpdateRemarkDialog = ({ userId, remark, nickname, isExistRemark, onClose }: UpdateRemarkDialogProps) => {
	const [value, setValue] = useState("");

	const createRemarkMutation = useCreateRemarkMutation();
	const updateRemarkMutation = useUpdateRemarkMutation();

	useEffect(() => {
		setValue(remark ?? "");
	}, [remark]);

	const handleSave = () => {
		if (isExistRemark) {
			updateRemarkMutation.mutate({ userId, remark: value });
		} else {
			createRemarkMutation.mutate({ userId, remark: value });
		}
		onClose();
	};

	return (
		<Dialog open onOpenChange={onClose}>
			<DialogContent className="max-w-124">
				<DialogHeader>
					<DialogTitle>{remark ? "Edit note" : "Add note"}</DialogTitle>
				</DialogHeader>
				<div className="mb-5 flex flex-col">
					<Typography type="p" padding="none" size="xs" color="msg_time">
						User
					</Typography>
					<Typography type="p" padding="none">
						{nickname}
					</Typography>
				</div>
				<Textarea
					value={value}
					rows={3}
					showCount
					maxLength={400}
					onChange={(e) => setValue(e.target.value)}
					className="rounded-md border-secondary"
				/>
				<DialogFooter>
					<Button type="secondary" onClick={onClose} wide>
						Cancel
					</Button>
					<Button type="primary" onClick={handleSave} wide>
						Save
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
